export enum HeaderFormatEnum {
    PageSizeLeft = "pagesizeleft",
    PageSizeRight = "pagesizeright",
}
